import React, { useEffect, useRef } from 'react';

const OTP_LENGTH = 6;

/**
 * CustomInputOTP
 *
 * Props:
 *  - value      {string}   current OTP string
 *  - onChange   {function} called with the new string value
 *  - error      {string}   error message to display below
 *  - setError   {function} clears the error when user types
 *  - length     {number}   number of OTP boxes (default 6)
 */
export default function CustomInputOTP ({ value, onChange, error, setError, length = OTP_LENGTH, label = '', hasError = false }) {
    const inputRef = useRef(null);

    const valueParts = value.split('');

    // Auto-focus on mount
    useEffect(() => {
        if (inputRef.current) inputRef.current.focus();
    }, []);

    function handleOnChange (e) {
        const digits = e.target.value.replace(/[^0-9]/g, '');
        if (error || hasError) {
            if (setError) setError(false);
        }
        if (onChange) onChange(digits.slice(0, length));
    }

    return (
        <div>
            {/* Wrapper with relative position so the overlay input works */}
            <div style={{ position: 'relative' }}>
                <div
                    className={`custom-input-otp-display${(error || hasError) ? ' custom-input-otp-display--error' : ''}`}
                >
                    {Array.from({ length }).map((_, index) => (
                        <span key={index} data-complete={valueParts[index] ? 'true' : 'false'}>
                            {valueParts[index] || ''}
                        </span>
                    ))}
                </div>
                <label className="visually-hidden" htmlFor="otp">
                    {label}
                </label>
                {/* Transparent overlay input — captures clicks and keyboard directly */}
                <input
                    ref={inputRef}
                    id="otp"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={length}
                    name="otp"
                    type="text"
                    value={value}
                    onChange={handleOnChange}
                    onFocus={(e) => e.target.select()}
                    onClick={(e) => e.target.select()}
                    style={{
                        position: 'absolute',
                        inset: 0,
                        opacity: 0,
                        cursor: 'text',
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                    }}
                />
            </div>
            {error && <p className="custom-input-otp-error">{error}</p>}
        </div>
    );
}
